// extracted by mini-css-extract-plugin
export default {"list":"NewFragmentNotify_list__cCofu","fragment":"NewFragmentNotify_fragment__yXXfl"};